import React from 'react';
import { useIntlV2 as useIntlDI } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { HelpPanelButton as HelpPanelButtonDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/help-panel-button/main.tsx';
import { ProjectFooter as ProjectFooterDI } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/project-footer/main.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { Link as LinkDI } from '@atlassian/react-resource-router';
import messages from './messages.tsx';
import type { FooterProps } from './types.tsx';

export const Footer = ({
	HelpPanelButton = HelpPanelButtonDI,
	Link = LinkDI,
	ProjectFooter = ProjectFooterDI,
	useIntl = useIntlDI,
}: FooterProps) => {
	const { formatMessage } = useIntl();

	const isAnonymous = useIsAnonymous();

	return (
		<ProjectFooter
			description={
				!isAnonymous && (
					<HelpPanelButton
						articleId="7qmj8lQILFCzcHlVGgC1JR"
						aria-label={formatMessage(messages.learnMoreAriaLabel)}
						fallbackComponent={
							<Link
								href="https://support.atlassian.com/jira-software-cloud/docs/what-are-team-managed-and-company-managed-projects/"
								target="_blank"
								aria-label={formatMessage(messages.learnMoreAriaLabel)}
							>
								{formatMessage(messages.learnMore)}
							</Link>
						}
					>
						{formatMessage(messages.learnMore)}
					</HelpPanelButton>
				)
			}
		>
			{formatMessage(messages.title)}
		</ProjectFooter>
	);
};
